module.exports = __webpack_public_path__ + "img/ic_dashboard.8762a636.svg";